// Mock data for Beechwood Dental Studio

export const clinicInfo = {
  name: "Beechwood Dental Studio",
  tagline: "Compassionate Dental Care for Every Smile",
  city: "Waterloo, ON",
  phone: "519.741.4141",
  email: "info@beechwooddentalstudio.ca",
  address: "18 Fischer-Hallman Rd N, Unit 202, Waterloo, ON",
  bookingUrl: "#book",
  hours: [
    { day: "Monday", time: "1:00 PM – 6:00 PM" },
    { day: "Tuesday", time: "9:00 AM – 5:00 PM" },
    { day: "Wednesday", time: "9:00 AM – 5:00 PM" },
    { day: "Thursday", time: "9:00 AM – 5:00 PM" },
    { day: "Friday", time: "9:00 AM – 1:00 PM" },
    { day: "Saturday", time: "Closed" },
    { day: "Sunday", time: "Closed" }
  ]
};

export const heroImage = "/img/clinic-operatory1-1200.webp";

export const imgSet = (name) => ({
  src: `/img/${name}-1200.webp`,
  srcSet: `/img/${name}-480.webp 480w, /img/${name}-800.webp 800w, /img/${name}-1200.webp 1200w`
});

export const galleryImages = [
  "/img/clinic-waiting-1200.webp",
  "/img/clinic-operatory2-1200.webp",
  "/img/clinic-operatory1-1200.webp"
];

export const clinicPhotos = {
  waitingRoom: "/img/clinic-waiting-1200.webp",
  operatory1: "/img/clinic-operatory1-1200.webp",
  operatory2: "/img/clinic-operatory2-1200.webp"
};

export const smileImage = "https://images.unsplash.com/photo-1489278353717-f64c6ee8a4d2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwxfHxoZWFsdGh5JTIwc21pbGV8ZW58MHx8fHwxNzkwNzk2NTA1fDA&ixlib=rb-4.1.0&q=85";
export const smileImage2 = "https://images.unsplash.com/photo-1548382131-e0ebb1f0cdea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwzfHxoZWFsdGh5JTIwc21pbGV8ZW58MHx8fHwxNzkwNzk2NTA1fDA&ixlib=rb-4.1.0&q=85";

export const team = [
  {
    id: 1,
    name: "Dr. Gabi Micheli",
    title: "D.D.S.",
    role: "Dentist",
    bio: "Dr. Gabi Micheli, who was born and raised in Kitchener, received her undergraduate degree in Biology at Wilfrid Laurier University. She then went on to complete her Doctor of Dental Surgery degree at Schulich School of Medicine and Dentistry in London, Ontario where she graduated with Distinction.\n\nDr. Gabi is passionate about providing exceptional patient care and always strives to learn more through continuing education. She treats her patients as if they are family and loves all aspects of general dentistry with a strong interest in surgery and orthodontics.\n\nDr. Gabi is a member of the CDA, ODA, and Waterloo Wellington Dental Association.\n\nOutside of dentistry, Dr. Gabi enjoys dancing, working out, travelling, and spending time with her husband, friends and family. Most recently, she welcomed her first baby boy and is loving this new chapter as a mom.",
    image: "/img/team-gabi-800.webp",
    imageSet: "/img/team-gabi-400.webp 400w, /img/team-gabi-800.webp 800w",
    imagePosition: "center top"
  },
  {
    id: 2,
    name: "Dr. Valerie Roth",
    title: "D.D.S.",
    role: "Dentist",
    bio: "Dr. Roth chose dentistry partly because of her family. Her father and uncle are well-respected local dentists, and her mother is a dental hygienist. After winning piano and typing competitions, Dr. Roth also knew she wanted a hands-on career that let her work with people.\n\nDr. Roth grew up in Kitchener, earned a BSc from the University of Waterloo, and received her dental degree from Western in 1988. She began as an associate under Dr. Richard Beyers, bought her father's practice when he retired in 1993, and opened her own practice on Park St. in 2002. It's an honour to now treat the children and grandchildren of her father's patients.\n\nDr. Roth is a member of the CDA, ODA, Waterloo Wellington Dental Association, and a local study club. Outside the office, she loves animals (especially dogs), time with family and friends, skiing in winter, and golf in summer.",
    image: "/img/team-roth-800.webp",
    imageSet: "/img/team-roth-400.webp 400w, /img/team-roth-800.webp 800w",
    imagePosition: "center top"
  }
];

export const services = [
  {
    id: "preventative",
    details: [
      "Prevention is the heart of everything we do at Beechwood. A healthy mouth rarely needs big, expensive work — it needs small, consistent care. Our hygienists take time with every cleaning, and our dentists use low-dose digital x-rays and intraoral cameras so you can see what we see and understand why we recommend something.",
      "For most patients a cleaning and exam every six months is ideal. If you have a history of gum disease, wear a night guard, or are prone to cavities, we may suggest a shorter interval. Children are welcome from their first tooth, and we make early visits short, fun and pressure-free so the dentist never becomes something to fear.",
      "Every preventative visit includes an oral cancer screening, a gum health check and a conversation about brushing, flossing and diet tailored to you. Our goal is simple: fewer surprises, less time in the chair, and a smile that lasts a lifetime."
    ],
    title: "Preventative Dentistry",
    short: "Cleanings, exams, and early care that protect your smile for a lifetime.",
    description: "Routine care and protective treatments designed to keep your teeth and gums healthy for life.",
    items: [
      {
        name: "Dental Cleanings & Exams",
        description: "Dental cleanings and exams are key to maintaining good oral health. Regular cleanings and exams help prevent decay and gum disease while catching potential problems early."
      },
      {
        name: "Dental Sealants",
        description: "Dental sealants are protective coatings applied to children's molars to help prevent cavities. They keep food and plaque from settling in deep grooves where decay often develops. Sealants are a simple, effective way to protect young teeth."
      },
      {
        name: "Night Guards",
        description: "Night guards are custom-fit dental appliances designed to protect teeth and improve comfort for patients who clench or grind. Professionally fitted night guards provide better protection without altering your bite."
      },
      {
        name: "Sports Guards",
        description: "Sports guards help protect teeth from injury during sports and physical activities. Custom-fit guards provide a secure, comfortable fit and better protection. We recommend wearing a sports guard during any activity where dental injuries may occur."
      }
    ],
    icon: "ShieldCheck",
    image: "/img/svc-preventative-1200.webp",
    imageSet: "/img/svc-preventative-600.webp 600w, /img/svc-preventative-1200.webp 1200w"
  },
  {
    id: "restorative",
    details: [
      "When a tooth is damaged by decay, a fracture or wear, restoring it quickly protects the rest of your mouth. At Beechwood we use tooth-coloured composite materials and high-strength ceramics so your restorations are as discreet as they are durable. Metal-free fillings, crowns and bridges blend naturally with your smile.",
      "Our digital workflow means many crowns and bridges are designed from a 3D scan rather than a messy impression, giving a more accurate fit and fewer adjustments. We'll always explain your options — including the cost of each and how your insurance applies — before any treatment begins.",
      "If you're missing teeth, we offer partial dentures, bridges and dental implants, and we'll walk you through which makes the most sense for your situation. Read our guide to implants, dentures and bridges on the blog, or book a consultation to get a personalised plan."
    ],
    title: "Restorative Dentistry",
    short: "Rebuild strength and function with modern, natural-looking restorations.",
    description: "Modern restorations that repair damage and rebuild function with a natural look and feel.",
    items: [
      {
        name: "Composite (Tooth-Coloured) Fillings",
        description: "Composite fillings are tooth-coloured restorations used to repair cavities and damaged teeth. They blend naturally with your smile for a discreet appearance and help restore the tooth's strength, function, and appearance."
      },
      {
        name: "Crowns & Bridges",
        description: "Crowns and bridges are custom-made restorations used to repair or replace damaged or missing teeth. Crowns cover and strengthen damaged teeth, while bridges replace missing teeth. Both restore your smile, function, and confidence."
      },
      {
        name: "Root Canals",
        description: "Root canals treat infected or damaged tooth roots and help preserve the natural tooth. The procedure removes the infected nerve and cleans and seals the inside of the tooth to relieve discomfort and prevent the infection from spreading."
      },
      {
        name: "Partial Dentures",
        description: "Partial dentures replace one or more missing teeth while fitting securely around your existing teeth. They restore your ability to chew and speak comfortably. Partial dentures are removable and can help restore your smile and confidence."
      }
    ],
    icon: "Wrench",
    image: "/img/svc-restorative-1200.webp",
    imageSet: "/img/svc-restorative-600.webp 600w, /img/svc-restorative-1200.webp 1200w"
  },
  {
    id: "cosmetic",
    details: [
      "Cosmetic dentistry at Beechwood is about enhancing what's already yours. Whether it's straightening teeth with Invisalign, closing a gap with bonding or brightening your smile with professional whitening, we plan every case around your face, your goals and your budget — never a one-size-fits-all template.",
      "Dr. Gabi Micheli has a special interest in orthodontics and is a certified Invisalign provider for teens and adults. Treatment begins with a digital scan and a preview of your projected result so you know what to expect before committing. Most cases are completed in 6 to 18 months with check-ins every six to eight weeks.",
      "Veneers and bonding are hand-finished and colour-matched chairside, and our take-home whitening uses custom trays for even, long-lasting results. We'll always start with a conversation about what bothers you and show you the most conservative path to get there."
    ],
    title: "Cosmetic Dentistry",
    short: "Refined smile design that highlights your natural beauty.",
    description: "Thoughtful, customized treatments that refresh and refine your smile.",
    items: [
      {
        name: "Invisalign\u00ae",
        description: "Invisalign uses custom-made, virtually invisible aligners to gently straighten your teeth. There are no metal brackets or wires, making treatment discreet and comfortable. The aligners are also removable, so eating, brushing, and flossing stay simple."
      },
      {
        name: "Composite Bonding",
        description: "Composite bonding uses tooth-coloured resin to improve the shape, colour, and appearance of your teeth. It's a minimally invasive treatment that can address chips, gaps, and minor imperfections. Bonding is customized to blend naturally with your smile."
      },
      {
        name: "Veneers",
        description: "Veneers are thin porcelain or ceramic shells designed to enhance the appearance of your teeth. They can improve the shape, colour and overall look of your smile. Veneers are custom-made to create a natural looking, beautiful result."
      },
      {
        name: "Teeth Whitening",
        description: "Teeth whitening treatments are designed to brighten your smile and remove stains and discolouration. Professional whitening can provide noticeable results, often several shades brighter. It's a safe and effective way to refresh your smile and boost your confidence."
      }
    ],
    icon: "Sparkles",
    image: "/img/svc-cosmetic-1200.webp",
    imageSet: "/img/svc-cosmetic-600.webp 600w, /img/svc-cosmetic-1200.webp 1200w"
  },
  {
    id: "surgical",
    details: [
      "Oral surgery doesn't have to be stressful. From simple extractions to wisdom teeth and dental implants, our surgical care is performed in our Waterloo studio by dentists who take the time to explain every step. We use modern local anaesthetic techniques and, for anxious patients or longer procedures, sedation options.",
      "Dental implants are placed and restored in-house by Dr. Gabi Micheli using high-quality implant systems and ceramic crowns. Treatment starts with a consultation and 3D imaging to assess your bone and plan the ideal position. Healing typically takes three to six months before the final crown is placed, and the result is built to last decades.",
      "After any surgical procedure you'll leave with clear written aftercare instructions and a direct line to our team. Most patients are back to normal routines within a day or two, and we follow up to make sure you're healing comfortably."
    ],
    title: "Surgical Dentistry",
    short: "Precise, comfortable procedures using the latest technology.",
    description: "Comfortable, precise surgical care with a focus on healing and long-term results.",
    items: [
      {
        name: "Simple Extractions",
        description: "Simple extractions are a quick, routine procedure where a visible tooth is gently loosened and removed under local anaesthesia. It is a painless and straightforward process to help restore your oral health with minimal downtime."
      },
      {
        name: "Surgical & Wisdom Teeth Extractions",
        description: "Surgical and wisdom teeth extractions remove problematic wisdom or other teeth that may be impacted, broken, or causing discomfort. Removing them can help prevent infection, damage, and future dental problems. Our team will ensure you're comfortable throughout the procedure and recovery."
      },
      {
        name: "Dental Implants",
        description: "Dental implants are a long-lasting solution for replacing missing teeth. They provide a strong, natural-looking foundation for a crown, bridge, or denture. Implants restore your smile, chewing function, and confidence."
      }
    ],
    icon: "Stethoscope",
    image: "/img/svc-surgical-1200.webp",
    imageSet: "/img/svc-surgical-600.webp 600w, /img/svc-surgical-1200.webp 1200w"
  },
  {
    id: "children",
    details: [
      "Children's dentistry at Beechwood is built around one goal: a child who grows up feeling at ease at the dentist. We recommend a first visit by age one or within six months of the first tooth. Early appointments are short and playful — a ride in the chair, a count of the teeth, and a chance for parents to ask about teething, bottles, thumb-sucking and brushing.",
      "As children grow, we add gentle cleanings, fluoride treatments and sealants on the permanent molars, and we watch how the adult teeth and jaws are developing so any orthodontic needs are caught early. Our team explains everything in kid-friendly language and never rushes a nervous child.",
      "We care for the whole family in one place, so parents can book their own check-ups alongside their children's. Sports guards for active kids, advice on healthy snacks, and tips for making brushing a habit are all part of the visit."
    ],
    title: "Children's Dentistry",
    short: "Gentle first visits and preventative care that set kids up for a lifetime of healthy smiles.",
    description: "Kind, unhurried dental care for infants, children and teens — from the very first tooth through the teenage years.",
    items: [
      {
        name: "First Dental Visits",
        description: "We recommend a first visit by age one or within six months of the first tooth. These early appointments are short and relaxed, helping children feel comfortable at the dentist from the start while we check development and answer parents' questions."
      },
      {
        name: "Children's Cleanings & Exams",
        description: "Gentle cleanings and check-ups tailored to little patients. We remove plaque, polish teeth, check for early decay and monitor how the baby and adult teeth are coming in."
      },
      {
        name: "Fluoride Treatments",
        description: "Professional fluoride strengthens developing enamel and makes it more resistant to cavities. A quick, painless application at the end of a cleaning offers months of added protection."
      },
      {
        name: "Sealants for Kids",
        description: "Thin protective coatings painted onto the chewing surfaces of children's molars seal out food and plaque where toothbrush bristles can't reach, dramatically lowering the risk of cavities."
      },
      {
        name: "Growth & Orthodontic Monitoring",
        description: "We track jaw growth and tooth alignment at every visit so crowding or bite issues can be addressed at the ideal time — often with simpler, shorter treatment."
      }
    ],
    icon: "Baby",
    image: "/img/svc-children-1200.webp",
    imageSet: "/img/svc-children-600.webp 600w, /img/svc-children-1200.webp 1200w"
  },
  {
    id: "emergency",
    details: [
      "Dental emergencies rarely happen at a convenient time. A toothache that keeps you up at night, a tooth chipped on a weekend, a crown that comes off before a trip — we understand how stressful it is, and we keep time in our schedule so we can see patients in pain quickly, usually the same day.",
      "When you call, our team will ask a few questions to understand what's happening and give you clear advice on what to do until you arrive. At your visit we focus first on relieving pain and stabilizing the problem, then talk through the options for a permanent fix — with clear pricing before anything begins.",
      "If you have severe swelling, difficulty breathing or swallowing, or an injury to the face or jaw, go to the nearest emergency room first. For everything else, call us at 519.741.4141 and we'll get you looked after."
    ],
    title: "Dental Emergency",
    short: "Same-day care when a toothache, break or lost filling can't wait.",
    description: "Fast, calm, same-day treatment for dental pain, injuries and infections — with honest guidance on what to do right now.",
    items: [
      {
        name: "Toothache & Dental Pain",
        description: "Persistent or severe tooth pain usually signals decay, infection or a cracked tooth. We'll find the cause, relieve the pain and explain what's needed to fix it for good."
      },
      {
        name: "Chipped, Cracked or Broken Teeth",
        description: "Whether from a fall, a sports injury or biting something hard, we repair damaged teeth with bonding, fillings or crowns to restore comfort and appearance quickly."
      },
      {
        name: "Knocked-Out Teeth",
        description: "Time matters. Keep the tooth moist in milk or saliva, avoid touching the root, and call us immediately — a tooth re-implanted within an hour has the best chance of being saved."
      },
      {
        name: "Lost Fillings or Crowns",
        description: "A lost filling or crown leaves the tooth sensitive and vulnerable. We'll protect the tooth and replace the restoration, often in a single visit."
      },
      {
        name: "Abscesses & Swelling",
        description: "Swelling in the gums or face points to infection that needs prompt attention. We drain and treat the infection, relieve the pressure and plan the treatment that prevents it from returning."
      }
    ],
    icon: "Siren",
    image: "/img/svc-emergency-1200.webp",
    imageSet: "/img/svc-emergency-600.webp 600w, /img/svc-emergency-1200.webp 1200w"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Jordan M.",
    role: "Patient since 2022",
    quote: "Beechwood exceeded my expectations. The team was professional and thoughtful, and I finally feel calm at the dentist.",
    rating: 5
  },
  {
    id: 2,
    name: "Alex R.",
    role: "Patient since 2023",
    quote: "I highly recommend Beechwood for their outstanding care and dedication. They genuinely listen and explain every step.",
    rating: 5
  },
  {
    id: 3,
    name: "Taylor S.",
    role: "Patient since 2021",
    quote: "The support I received was phenomenal. From booking to follow-up, everything was seamless and truly patient-first.",
    rating: 5
  },
  {
    id: 4,
    name: "Priya K.",
    role: "Patient since 2024",
    quote: "Modern office, warm team, and the best cleaning I've had in years. My whole family comes here now.",
    rating: 5
  }
];

export const values = [
  { title: "Gentle Care", description: "Comfort-first appointments designed around you.", icon: "HandHeart" },
  { title: "Modern Technology", description: "Digital scanners, low-dose imaging, and precise tools.", icon: "Cpu" },
  { title: "Clear Communication", description: "Honest conversations about treatment and cost.", icon: "MessageCircle" },
  { title: "Family Friendly", description: "Welcoming environment for every age and stage.", icon: "Users" }
];

export const faqs = [
  {
    q: "Do you accept new patients?",
    a: "Yes! We're actively welcoming new patients and families. New patient exams typically take about 60 minutes and include a full exam, digital x-rays, and a conversation about your dental health and goals."
  },
  {
    q: "Do you accept the Canadian Dental Care Plan (CDCP)?",
    a: "Yes. We accept CDCP and will help you understand your coverage. We offer assignment and direct billing so we can submit claims to CDCP on your behalf \u2014 you only pay any remaining balance."
  },
  {
    q: "What are your hours?",
    a: "We're open Monday 1pm\u20136pm, Tuesday to Thursday 9am\u20135pm, and Friday 9am\u20131pm. Closed weekends."
  },
  {
    q: "How do I book an appointment?",
    a: "Use the Book Online button at the top of any page, call us at 519.741.4141, or email info@beechwooddentalstudio.ca. We respond within one business day."
  },
  {
    q: "What if I have dental anxiety?",
    a: "Our team is trained to make anxious patients comfortable \u2014 from a calm, unhurried pace to sedation options for longer procedures. Please tell us how you're feeling; we'll adjust our approach to you."
  },
  {
    q: "Do you see children?",
    a: "Yes, we care for patients of all ages, starting from age one for their first happy visit. Both Dr. Gabi and Dr. Roth love working with families."
  },
  {
    q: "How often should I come in for a cleaning?",
    a: "Most patients benefit from a professional cleaning and exam every six months. If you're at higher risk for cavities or gum disease, we may recommend more frequent visits."
  },
  {
    q: "Do you offer Invisalign\u00ae?",
    a: "Yes. We offer Invisalign clear aligners for teens and adults. Book a consultation and we'll assess whether it's the right option for your smile."
  },
  {
    q: "What should I bring to my first visit?",
    a: "Please bring a piece of ID, your insurance details (if any), and a list of any medications you take. If you have recent x-rays from another dentist, feel free to bring them or ask us to request them."
  },
  {
    q: "Do you handle dental emergencies?",
    a: "Yes. If you're an existing patient experiencing a dental emergency, please call us and we'll do our best to see you the same day. New patients are also welcome to reach out."
  },
  {
    q: "Is parking available?",
    a: "Yes, free parking is available in our on-site lot at 18 Fischer-Hallman Rd N, Unit 202. The clinic is also accessible by public transit."
  },
  {
    q: "Do you offer direct billing to insurance?",
    a: "Yes. We bill most major insurance providers directly, so you only pay the portion your plan doesn't cover at the time of your visit. Bring your insurance card or plan details to your first appointment and we'll take care of the paperwork."
  },
  {
    q: "What payment options do you accept?",
    a: "We accept debit, Visa, Mastercard, American Express and cash. For larger treatments such as implants, Invisalign or crowns, we can discuss flexible payment arrangements so cost never gets in the way of care you need."
  },
  {
    q: "Do you offer dental implants?",
    a: "Yes. Dr. Gabi Micheli places and restores dental implants in-office using high-quality implant systems and ceramic crowns. A consultation includes an exam, a 3D scan if needed, and a clear treatment plan and quote before anything begins."
  },
  {
    q: "Do you offer teeth whitening?",
    a: "We offer professional take-home whitening with custom-fitted trays, which gives safe, even results that are several shades brighter than over-the-counter products. We'll check your teeth first to make sure whitening is right for you."
  },
  {
    q: "How long does a root canal take, and does it hurt?",
    a: "Most root canals are completed in one or two visits of 60 to 90 minutes. With modern local anaesthetic the procedure itself is comfortable \u2014 most patients say it feels like having a filling done \u2014 and it relieves the pain caused by the infected tooth."
  },
  {
    q: "When should my child first see the dentist?",
    a: "We recommend a first visit by age one, or within six months of the first tooth appearing. Early visits are short and relaxed \u2014 a quick look, a ride in the chair, and a chance for parents to ask about teething, brushing and bottles \u2014 so children grow up comfortable at the dentist."
  }];
